(function () {
  "use strict";
  var ROOT = document.getElementById("no-advcoti");
  if (!ROOT) return;
  var CDN = "https://nightoperators-adv-coti.lovable.app";
  var KIT_SAVING = 200; /* PVS-31 kits; PVS-14 kits carry their own off: 150 (Bon 14 Oct) */
  var VARIANTS = {
    ADV_COTI: "51821080084726", PVS14_PRO_1400: "50748972663030", PVS14_STD_1400: "50748972531958",
    PVS31_1400: "50751937872118", PVS31_1600: "50751937904886",
    "addon-helmet-blk-m": "51760827728118", "addon-helmet-blk-l": "51760827760886"
  };
  /* round 4 (14 Oct, Bon): every FOM tier on the PVS-14 and PVS-31 kit cards, picked with a slider.
     [variant id, price, compare at]; price and compare are re-read from the live product JSON on load. */
  var T14 = [
    { fom: "1250-1350", short: "1250", PRO: ["50652605907190", 1784.95, 4659.95], STANDARD: null },
    { fom: "1400-1550", short: "1400", PRO: ["50748972663030", 1884.95, 4859.95], STANDARD: ["50748972531958", 1849.95, 4789.95] },
    { fom: "1600-1750", short: "1600", PRO: ["50861859864822", 2334.95, 5839.95], STANDARD: ["50861859799286", 2299.95, 5749.95] },
    { fom: "1800-2000", short: "1800", PRO: ["50748972695798", 2484.95, 6059.95], STANDARD: ["50748972564726", 2449.95, 5989.95] }
  ];
  var T31 = [
    { fom: "1400-1550", short: "1400", v: ["50751937872118", 3799.95, 7599.00] },
    { fom: "1600-1800", short: "1600", v: ["50751937904886", 4449.95, 10399.95] },
    { fom: "1800-1950", short: "1800", v: ["51017700999414", 4949.95, 10599.95] },
    { fom: "2000-2100", short: "2000", v: ["50752033161462", 5399.95, 10799.95] }
  ];
  var PRICE = {}, CMP = {};
  PRICE[VARIANTS.ADV_COTI] = 2949.00; CMP[VARIANTS.ADV_COTI] = 3999.00;
  var KITS = { "adv-coti-alone": { name: "Jerry-C Pro", lines: [VARIANTS.ADV_COTI] } };
  function id14(model, t) { return (model === "STANDARD" ? "adv-coti-pvs14-std" : "adv-coti-pvs14") + (t.short === "1400" ? "" : "-" + t.short); }
  function id31(t) { return "adv-coti-pvs31-" + t.short; }
  T14.forEach(function (t, i) {
    ["PRO", "STANDARD"].forEach(function (m) {
      var v = t[m]; if (!v) return;
      PRICE[v[0]] = v[1]; CMP[v[0]] = v[2];
      KITS[id14(m, t)] = { name: "Jerry-C Pro + PVS-14 " + m + " " + t.short, off: 150, lines: [v[0], VARIANTS.ADV_COTI], card: "14", model: m, tier: i };
    });
  });
  T31.forEach(function (t, i) {
    PRICE[t.v[0]] = t.v[1]; CMP[t.v[0]] = t.v[2];
    KITS[id31(t)] = { name: "Jerry-C Pro + PVS-31 " + t.short, off: 200, lines: [t.v[0], VARIANTS.ADV_COTI], card: "31", tier: i };
  });
  var HELMET_PRICE = 149.95;
  var helmet = { selected: false, color: "BLK", size: "M" };
  var stock = {}, stockError = false, helmetReady = false, helmetError = false, sending = false;
  var helmetImages = {
    BLK: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-blk.webp?v=1792014202",
    TAN: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-tan.webp?v=1792014222",
    RG: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-rg-nc1019.webp?v=1792014212"
  };
  var modal = null, previousFocus = null, activeImage = null, imageTimer = null;
  function $(s, c) { return (c || ROOT).querySelector(s); }
  function $$(s, c) { return Array.from((c || ROOT).querySelectorAll(s)); }
  function fmt(n) { return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  /* round 4 (14 Oct 2026, Bon): we only sell the VENTED helmet now. COLOR-SIZE to variant id, read from the live
     helmet product, VENTED shell only, so a new vented colour or size shows up here by itself once it is in stock. */
  function noVented(p) {
    var out = {}; if (!p || !p.variants) return out;
    var names = (p.options || []).map(function (o) { return String(o && o.name != null ? o.name : o).toUpperCase(); });
    var iS = names.indexOf("SIZE"), iC = names.indexOf("COLOR"), iH = names.indexOf("SHELL");
    if (iS < 0 || iC < 0 || iH < 0) return out;
    var SZ = { MEDIUM: "M", LARGE: "L" }, CO = { BLACK: "BLK", "RANGER GREEN": "RG", TAN: "TAN" };
    p.variants.forEach(function (v) {
      var o = v.options || [v.option1, v.option2, v.option3];
      if (String(o[iH]).toUpperCase() !== "VENTED") return;
      var z = SZ[String(o[iS]).toUpperCase()], c = CO[String(o[iC]).toUpperCase()];
      if (z && c) out[c + "-" + z] = String(v.id);
    });
    return out;
  }
  function helmetNoneLeft() {
    var ids = Object.keys(VARIANTS).filter(function (k) { return /^addon-helmet-/.test(k); }).map(function (k) { return VARIANTS[k]; });
    return helmetReady && ids.length > 0 && ids.every(function (i) { return stock[i] === false; });
  }
  function helmetId() { return VARIANTS["addon-helmet-" + helmet.color.toLowerCase() + "-" + helmet.size.toLowerCase()]; }
  function offOf(kit) { return kit.lines.length > 1 ? (kit.off != null ? kit.off : KIT_SAVING) : 0; }
  function sum(kit, map) { return kit.lines.reduce(function (s, id) { return s + (map[id] || 0); }, 0); }
  function total(kit) { return sum(kit, PRICE) - offOf(kit) + (helmet.selected ? HELMET_PRICE : 0); }
  function available(kit) { return kit.lines.every(function (id) { return stock[id] === true; }); }
  function soldOut(kit) { return kit.lines.some(function (id) { return stock[id] === false; }); }
  function optionButton(value, kind) {
    var b = document.createElement("button"); b.type = "button"; b.className = "no-option";
    b.textContent = value; b.dataset.helmetKind = kind; b.dataset.helmetValue = value;
    b.addEventListener("click", function (e) {
      e.stopPropagation(); helmet[kind] = value;
      if (helmet.selected && stock[helmetId()] !== true) helmet.selected = false;
      paint();
    }); return b;
  }
  function makeOptions(host) {
    ["BLK", "TAN", "RG"].forEach(function (v) { host.appendChild(optionButton(v, "color")); });
    ["M", "L"].forEach(function (v) { host.appendChild(optionButton(v, "size")); });
  }
  function paintOptions(host) {
    $$("[data-helmet-kind]", host).forEach(function (b) {
      var kind = b.dataset.helmetKind, v = b.dataset.helmetValue;
      var id = VARIANTS["addon-helmet-" + (kind === "color" ? v : helmet.color).toLowerCase() + "-" + (kind === "size" ? v : helmet.size).toLowerCase()];
      b.disabled = stock[id] !== true;
      b.style.display = (kind === "color" ? !["m", "l"].some(function (z) { var i2 = VARIANTS["addon-helmet-" + v.toLowerCase() + "-" + z]; return i2 && stock[i2] !== false; }) : (!id || stock[id] === false)) ? "none" : "";
      b.setAttribute("aria-pressed", String(helmet[kind] === v));
      b.title = stock[id] === false ? "Sold out" : stock[id] === true ? v : "Stock unavailable";
    });
  }
  /* FOM slider (round 4). stops: one kit per tier, null when the tier is not made for that housing. */
  function fomState(k) { return !k ? "none" : soldOut(k) ? "sold" : "ok"; }
  function paintFom(card, stops, idx) {
    var box = $("[data-r4-fom]", card); if (!box) return;
    var n = stops.length, input = $("input", box), pct = n > 1 ? idx / (n - 1) * 100 : 0;
    input.max = String(n - 1); input.value = String(idx);
    var tiers = card.hasAttribute("data-pvs31-card") ? T31 : T14;
    input.setAttribute("aria-valuetext", tiers[idx].fom + " FOM");
    box.style.setProperty("--r4f-pct", pct + "%");
    $("[data-r4-fom-value]", box).textContent = tiers[idx].fom;
    var notes = [];
    $$("[data-r4-stop]", box).forEach(function (b, i) {
      var st = fomState(stops[i]);
      b.dataset.state = st; b.setAttribute("aria-pressed", String(i === idx));
      b.disabled = st !== "ok";
      b.title = st === "sold" ? tiers[i].fom + ": sold out" : st === "none" ? tiers[i].fom + ": not made in this housing" : tiers[i].fom + " FOM";
      if (st === "sold") notes.push(tiers[i].fom + " sold out");
      if (st === "none") notes.push(tiers[i].fom + " PRO only");
    });
    $$("[data-r4-dot]", box).forEach(function (d, i) { d.dataset.state = fomState(stops[i]); d.dataset.on = String(i <= idx); });
    $("[data-r4-fom-note]", box).textContent = "Higher FOM, sharper and cleaner image." + (notes.length ? " " + notes.join(", ") + "." : "");
  }
  function nearestOk(stops, want) {
    if (stops[want] && fomState(stops[want]) !== "sold") return want;
    for (var d = 1; d < stops.length; d++) {
      if (stops[want + d] && fomState(stops[want + d]) === "ok") return want + d;
      if (stops[want - d] && fomState(stops[want - d]) === "ok") return want - d;
    }
    return want;
  }
  function paint() {
    $$("[data-kit-id]").forEach(function (card) {
      var kit = KITS[card.dataset.kitId]; if (!kit) return;
      var sold = soldOut(kit), ok = available(kit) && (!helmet.selected || stock[helmetId()] === true);
      card.classList.toggle("no-sold-out", sold);
      card.classList.remove("opacity-50", "grayscale", "line-through");
      card.setAttribute("aria-disabled", String(!ok));
      $("[data-kit-total]", card).textContent = fmt(total(kit));
      if (card.hasAttribute("data-pvs31-card")) {
        var t31 = T31[kit.tier];
        $("[data-kit-compare]", card).textContent = fmt(sum(kit, CMP));
        var bestFor = "PVS-31 PRO, " + t31.fom + " FOM, plus the Jerry-C Pro on one tube.";
        $("[data-kit-best-for]", card).textContent = bestFor;
        var feature = $("ul li span", card); if (feature) feature.textContent = bestFor;
        paintFom(card, T31.map(function (t) { return KITS[id31(t)]; }), kit.tier);
      }
      if (card.hasAttribute("data-pvs14-card")) {
        var model = kit.model, t14 = T14[kit.tier];
        var label = "+ PVS-14 " + model + " " + t14.short;
        var bestFor14 = "PVS-14 " + model + ", " + t14.fom + " FOM, plus the Jerry-C Pro.";
        $("[data-kit-compare]", card).textContent = fmt(sum(kit, CMP));
        $("[data-kit-best-for]", card).textContent = bestFor14;
        $("[data-kit-label]", card).textContent = sold ? "SOLD OUT" : label;
        $("[data-kit-name]", card).textContent = label;
        var feature14 = $("ul li span", card); if (feature14) feature14.textContent = bestFor14;
        $$("[data-pvs14-model]", card).forEach(function (button) {
          var m = button.dataset.pvs14Model;
          var anyOk = T14.some(function (t) { var k = KITS[id14(m, t)]; return k && !soldOut(k); });
          var selected14 = m === model;
          button.disabled = !anyOk;
          button.setAttribute("aria-pressed", String(selected14));
          button.className = "flex-1 h-auto mono text-[11px] font-bold tracking-[0.12em] uppercase px-2 py-2 rounded-full border transition-colors " + (button.disabled ? "border-transparent bg-background/20 text-muted-foreground/50 line-through cursor-not-allowed" : selected14 ? "border-accent bg-accent/15 text-accent" : "border-transparent bg-background/30 text-muted-foreground hover:border-accent/40 hover:text-foreground");
        });
        paintFom(card, T14.map(function (t) { return KITS[id14(model, t)] || null; }), kit.tier);
      }
      var saving = $("[data-kit-saving]", card);
      saving.hidden = !(offOf(kit) > 0);
      saving.textContent = "Save " + fmt(offOf(kit)).replace(".00", "");
      var cart = $("[data-kit-cart]", card); cart.disabled = !ok || sending;
      cart.textContent = sending ? "ADDING TO CART" : sold ? "SOLD OUT" : !available(kit) ? (stockError ? "STOCK UNAVAILABLE" : "CHECKING STOCK") : "Get " + kit.name + (helmet.selected ? " + Helmet" : "") + ", " + fmt(total(kit)) + "\u00a0→";
      var image = $("[data-kit-image]", card); image.disabled = !ok || sending;
      var overlay = $("[role=button]", image);
      if (overlay) { var active = activeImage === card.dataset.kitId; overlay.style.opacity = active ? "1" : "0"; overlay.style.pointerEvents = active ? "auto" : "none"; overlay.tabIndex = active ? 0 : -1; overlay.setAttribute("aria-hidden", String(!active)); }
      var row = $("[data-helmet-row]", card), toggle = $("[data-helmet-toggle]", row);
      row.style.display = helmetNoneLeft() ? "none" : "";
      toggle.disabled = stock[helmetId()] !== true;
      toggle.setAttribute("aria-checked", String(helmet.selected));
      toggle.title = stock[helmetId()] === false ? "Sold out" : helmetReady ? "Select helmet" : helmetError ? "Helmet stock unavailable" : "Checking helmet stock";
      toggle.classList.toggle("bg-accent/15", helmet.selected);
      toggle.classList.toggle("border-accent", helmet.selected);
      var knob = toggle.firstElementChild;
      if (knob) knob.style.transform = helmet.selected ? "translate(20px,-50%)" : "translate(0,-50%)";
      var img = $("img", row); if (img) img.src = helmetImages[helmet.color];
      paintOptions(row);
    });
    if (modal) {
      $("[data-popup-image]", modal).src = helmetImages[helmet.color];
      paintOptions(modal);
      var button = $("[data-popup-toggle]", modal);
      button.disabled = stock[helmetId()] !== true;
      button.textContent = stock[helmetId()] === false ? "SOLD OUT" : stock[helmetId()] !== true ? "HELMET STOCK UNAVAILABLE" : helmet.selected ? "REMOVE HELMET" : "ADD HELMET, $149.95";
    }
  }
  function toggleHelmet() { if (helmet.selected || stock[helmetId()] === true) { helmet.selected = !helmet.selected; paint(); } }
  function closeModal() {
    if (!modal) return;
    modal.remove(); modal = null;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  }
  function positionModal() {
    if (!modal) return;
    var rect = ROOT.getBoundingClientRect();
    $(".no-modal-panel", modal).style.top = Math.max(16, -rect.top + 16) + "px";
  }
  function openHelmet() {
    closeModal(); previousFocus = document.activeElement;
    modal = document.createElement("div"); modal.className = "no-modal-root";
    modal.innerHTML = '<div class="no-modal-overlay"></div><div class="no-modal-panel" role="dialog" aria-modal="true" aria-labelledby="no-helmet-title"><button type="button" class="no-modal-close" aria-label="Close helmet details">✕</button><div class="mono text-accent">NEW · GEN II</div><h3 id="no-helmet-title" class="heading-display text-[24px]">NIGHT OPERATORS GEN II FAST SF VENTED HELMET</h3><img data-popup-image alt="Gen II FAST SF vented helmet"><p class="heading-display text-accent text-[24px]">$149.95</p><div data-popup-options class="flex flex-wrap gap-2 mt-4"></div><p class="text-muted-foreground mt-4">Vented shell · Memory-foam pad · ARC rails · Non-ballistic</p><button type="button" data-popup-toggle class="btn-primary w-full mt-4"></button><p class="text-muted-foreground mt-3">Adds to the selected kit in the same cart request.</p></div>';
    ROOT.appendChild(modal); makeOptions($("[data-popup-options]", modal));
    $(".no-modal-overlay", modal).addEventListener("click", closeModal);
    $(".no-modal-close", modal).addEventListener("click", closeModal);
    $("[data-popup-toggle]", modal).addEventListener("click", toggleHelmet);
    positionModal(); paint(); $(".no-modal-close", modal).focus();
  }
  document.addEventListener("keydown", function (e) {
    if (!modal) return;
    if (e.key === "Escape") { e.preventDefault(); closeModal(); }
    if (e.key === "Tab") {
      var items = $$("button:not(:disabled),a[href],input:not(:disabled)", modal), first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener("scroll", positionModal, { passive: true }); window.addEventListener("resize", positionModal);
  function addKit(kit) {
    if (sending || !available(kit) || (helmet.selected && stock[helmetId()] !== true)) return;
    var items = kit.lines.map(function (id) { return { id: id, quantity: 1 }; });
    if (helmet.selected) items.push({ id: helmetId(), quantity: 1 });
    sending = true; paint();
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error("Cart request failed"); return r.json(); })
      .then(function (j) { if (window.noCartDrawerOpen) { sending = false; paint(); window.noCartDrawerOpen(j); } else { window.location.assign("/cart"); } })
      .catch(function () { sending = false; paint(); alert("We could not add your selection to the cart. Please try again or email info@nightoperators.com."); });
  }
  function initKits() {
    $$("[data-kit-id]").forEach(function (card) {
      function selectedKit() { return KITS[card.dataset.kitId]; }
      function stopsFor(c, model) {
        return c.hasAttribute("data-pvs31-card") ? T31.map(function (t) { return KITS[id31(t)]; })
          : T14.map(function (t) { return KITS[id14(model, t)] || null; });
      }
      function pick(i, model) {
        var k = selectedKit(), m = model || k.model;
        var stops = stopsFor(card, m), j = nearestOk(stops, i);
        if (!stops[j]) return;
        card.dataset.kitId = card.hasAttribute("data-pvs31-card") ? id31(T31[j]) : id14(m, T14[j]);
        activeImage = null; paint();
      }
      $$("[data-pvs14-model]", card).forEach(function (button) {
        button.addEventListener("click", function () { pick(selectedKit().tier, button.dataset.pvs14Model); });
      });
      var fomBox = $("[data-r4-fom]", card);
      if (fomBox) {
        var input = $("input", fomBox);
        input.addEventListener("input", function () { pick(Number(input.value)); });
        $$("[data-r4-stop]", fomBox).forEach(function (b, i) { b.addEventListener("click", function (e) { e.stopPropagation(); pick(i); }); });
      }
      $("[data-kit-cart]", card).addEventListener("click", function () { addKit(selectedKit()); });
      var image = $("[data-kit-image]", card), overlay = $("[role=button]", image);
      image.addEventListener("click", function () { activeImage = card.dataset.kitId; clearTimeout(imageTimer); paint(); imageTimer = setTimeout(function () { activeImage = null; paint(); }, 3000); });
      if (overlay) {
        overlay.addEventListener("click", function (e) { e.stopPropagation(); addKit(selectedKit()); });
        overlay.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); addKit(selectedKit()); } });
      }
      var row = $("[data-helmet-row]", card); makeOptions($("[data-helmet-options]", row));
      $("[data-helmet-toggle]", row).addEventListener("click", function (e) { e.stopPropagation(); toggleHelmet(); });
      var open = $("[data-helmet-open]", row); if (open) open.addEventListener("click", function (e) { e.stopPropagation(); openHelmet(); });
      row.addEventListener("click", function (e) { if (!e.target.closest("button")) openHelmet(); });
      row.addEventListener("keydown", function(e) { if(e.target===row && (e.key==="Enter" || e.key===" ")) {e.preventDefault();openHelmet();} });
    }); paint();
  }
  function readProduct(path) {
    return fetch(path, { headers: { "Accept": "application/json" } }).then(function (r) { if (!r.ok) throw new Error("Stock unavailable"); return r.json(); }).then(function (p) {
      if (!Array.isArray(p.variants)) throw new Error("Stock unavailable");
      p.variants.forEach(function (v) { var id = String(v.id); stock[id] = v.available === true;
        if (id in PRICE && typeof v.price === "number") PRICE[id] = v.price / 100;
        if (id in CMP && typeof v.compare_at_price === "number" && v.compare_at_price > 0) CMP[id] = v.compare_at_price / 100; }); return p;
    });
  }
  function loadStock() {
    Promise.all(["/products/adv-coti-clip-on-thermal-imager.js", "/products/pvs-14-night-vision-monocular.js", "/products/pvs-31-pro-night-vision-binocular.js"].map(readProduct)).then(paint).catch(function () { stockError = true; paint(); });
    readProduct("/products/fast-sf-helmet.js").then(function (p) { var vm = noVented(p); Object.keys(vm).forEach(function (k) { VARIANTS["addon-helmet-" + k.toLowerCase()] = vm[k]; }); if (stock[helmetId()] !== true) { var f = Object.keys(vm).filter(function (k) { return stock[vm[k]] === true; })[0]; if (f) { helmet.color = f.split("-")[0]; helmet.size = f.split("-")[1]; } } helmetReady = true; paint(); }).catch(function () { helmetError = true; paint(); });
  }
  function initSliders() {
    $$("[data-comparison]").forEach(function (frame) {
      var input = $("input[type=range]", frame), before = $("[data-before-layer]", frame);
      function update(v) {
        v = Math.max(0, Math.min(100, v)); input.value = String(v);
        before.style.clipPath = "inset(0 " + (100 - v) + "% 0 0)";
        $$("[data-comparison-handle]", frame).forEach(function (x) { x.style.left = v + "%"; });
        input.setAttribute("aria-valuetext", Math.round(v) + " percent without Jerry-C Pro");
      }
      function pointer(e) { var r = frame.getBoundingClientRect(); update((e.clientX - r.left) / r.width * 100); }
      input.addEventListener("input", function () { update(Number(input.value)); });
      input.addEventListener("pointerdown", function (e) { input.setPointerCapture(e.pointerId); pointer(e); });
      input.addEventListener("pointermove", function (e) { if (input.hasPointerCapture(e.pointerId)) pointer(e); }); update(50);
    });
  }
  function initFaq() {
    var faq = $("#faq");
    if (!faq) return;
    var rows = $$(".border-b.border-border-bright", faq);
    var open = 0;
    var panels = rows.map(function (row) {
      return { btn: row.querySelector("button"), body: row.querySelector("button + div"), plus: row.querySelector("button span:last-child") };
    }).filter(function (p) { return p.btn && p.body; });

    function paint() {
      panels.forEach(function (p, i) {
        var isOpen = open === i;
        p.btn.setAttribute("aria-expanded",String(isOpen));
        p.body.style.maxHeight = isOpen ? "1400px" : "0";
        p.body.className = "overflow-hidden transition-all duration-300 text-muted-foreground text-[17px] leading-[1.65] px-5 md:px-6 " +
          (isOpen ? "max-h-[1400px] pb-7" : "max-h-0");
        if (p.plus) {
          p.plus.className = "mono text-2xl text-accent flex-shrink-0 transition-transform duration-200 " + (isOpen ? "rotate-45" : "");
        }
      });
    }
    panels.forEach(function (p, i) {
      p.btn.addEventListener("click", function () { open = open === i ? null : i; paint(); });
    });
    paint();
  }

  function initViperExpand() {
    var section = $("#viper-vs-pvs14");
    if (!section) return;
    var btn = section.querySelector('button[aria-controls="viper-vs-pvs14"]');
    var body = section.querySelector(".relative.overflow-hidden.transition-\\[max-height\\]") ||
      section.querySelector('[class*="transition-[max-height]"]');
    if (!btn || !body) return;
    var fade = body.querySelector(".pointer-events-none.absolute.inset-x-0.bottom-0");
    var chevron = btn.querySelector("svg");
    var open = false;
    function paint() {
      body.style.maxHeight = open ? "4000px" : "180px";
      body.className = body.className.replace(/max-h-\[\d+px\]/, open ? "max-h-[4000px]" : "max-h-[180px]");
      if (!/max-h-\[/.test(body.className)) body.className += open ? " max-h-[4000px]" : " max-h-[180px]";
      if (fade) fade.style.display = open ? "none" : "";
      if (chevron) chevron.classList.toggle("rotate-180", open);
      btn.childNodes[0].nodeValue = open ? "Collapse" : "Expand Comparison";
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    }
    btn.addEventListener("click", function () { open = !open; paint(); });
    paint();
  }

  function initVideos() {
    var scrubbed = [];
    $$("section[aria-label]").forEach(function (s) {
      var l = s.getAttribute("aria-label");
      if (/housing|J-arm|PVS-31 PRO/.test(l)) {
        $$("video", s).forEach(function (v) { scrubbed.push(v); });
      }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (scrubbed.indexOf(v) !== -1) return; // scrub videos are driven by scroll
        if (entry.isIntersecting) {
          if (v.hasAttribute("controls") && v.dataset.noUserPlayed !== "1") return;
          if (!v.hasAttribute("controls")) v.muted = true;
          v.playsInline = true;
          if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.2 });

    $$("video").forEach(function (v) {
      v.muted = true;
      v.playsInline = true;
      v.addEventListener("play", function () {
        v.dataset.noUserPlayed = "1";
        if (v.hasAttribute("controls") && v.muted) v.muted = false;
      });
      io.observe(v);
    });
  }

  /* ---------------------------------------------------------------------------
     9. In-page anchor links, smooth scroll without hijacking the host theme
     ------------------------------------------------------------------------ */
  function initAnchors() {
    ROOT.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || !ROOT.contains(a)) return;
      var id = a.getAttribute("href").slice(1);
      if (!id) return;
      var target = document.getElementById(id) || ROOT.querySelector("#" + CSS.escape(id));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }


  function initMechanism() {
    var section = $("#legit"); if (!section) return;
    var buttons = $$("button.border-destructive", section), active = null, panel = null;
    var descriptions = [
      "US dealer listings for this class run about $3,187 to $4,475, read October 2026. The most common regular price is $3,999.",
      "Jerry-C Pro is not kept on our shelf. To the USA it arrives in roughly 3 weeks from your order date; elsewhere roughly 3 to 6 weeks. The delivery window is shown before you pay.",
      "Wireless remote, external battery pack with cable and clamp ring set for our PVS-14 and PVS-31 objectives are included."
    ];
    function show(i) {
      active = i; if (panel) panel.remove(); panel = null;
      buttons.forEach(function (b,j) { b.setAttribute("aria-expanded", String(i===j)); });
      if (i == null) return;
      panel = document.createElement("div"); panel.className = "mt-4 bg-background/20 border-l-[3px] border-l-accent p-5";
      panel.setAttribute("aria-live", "polite"); panel.textContent = descriptions[i];
      buttons[0].closest(".mx-auto").appendChild(panel);
    }
    buttons.forEach(function (b,i) {
      b.addEventListener("click", function () { show(active === i ? null : i); });
      b.addEventListener("pointerenter", function(e) { if(e.pointerType!=="touch") show(i); });
      b.addEventListener("pointerleave", function(e) { if(e.pointerType!=="touch") show(null); });
      b.addEventListener("focus", function() { show(i); }); b.addEventListener("blur", function() { show(null); });
    });
  }
  function initScrollPieces() {
    // The Jerry-C Pro fit and reveal stages use stills. Native sticky pins retain
    // their original scroll durations; tracking leaders stay attached to stills.
    var sections = $$("section[aria-label]").filter(function(s) { return /Jerry-C Pro on|Jerry-C Pro on|Fits your/.test(s.getAttribute("aria-label")); });
    function update() {
      sections.forEach(function(s) {
        var stage = $(".sticky", s) || s.firstElementChild, card = $("[data-callout-card]", s);
        if(!stage || !card) return;
        var dot = $(".will-change-transform", s), path = $("path[stroke]", s), rect = stage.getBoundingClientRect(), cr = card.getBoundingClientRect();
        var x = rect.width * .5, y = rect.height * .45;
        if(dot) dot.style.transform = "translate3d("+x+"px,"+y+"px,0) translate(-50%,-50%)";
        if(path) path.setAttribute("d", "M "+x+" "+y+" L "+(cr.left-rect.left)+" "+(cr.top-rect.top));
      });
    }
    var pending=false;
    function schedule() { if(pending)return;pending=true;requestAnimationFrame(function(){pending=false;update();}); }
    window.addEventListener("scroll",schedule,{passive:true});window.addEventListener("resize",schedule);update();
  }
  initKits(); initSliders(); initFaq(); initViperExpand(); initMechanism(); initScrollPieces(); initVideos(); initAnchors(); loadStock();
})();
